import { Component } from '@angular/core';
import { IonApp, IonRouterOutlet, Platform } from '@ionic/angular/standalone';
import { register } from 'swiper/element/bundle';
import { environment } from '../environments/environment';

register();


@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  standalone: true,
  imports: [IonApp, IonRouterOutlet],
})
export class AppComponent {
  constructor(private platform: Platform) {
    this.platform.ready().then(() => {
      if ('serviceWorker' in navigator) {
          navigator.serviceWorker
              .register('firebase-messaging-sw.js')
              .then((registration) => {
                  // console.log('Service Worker registered with scope:', registration.scope);
              })
              .catch((error) => {
                  console.error('Service Worker registration failed:', error);
              });
      }
  });
}
  
}
